export default __webpack_public_path__ + "static/media/049-siren.b65501f7.png";